import React, { Fragment } from "react";
import { useParams } from "react-router-dom";
//
import { useForm } from "react-hook-form";
//
import { useQuery, useMutation } from "@apollo/react-hooks";
import gql from "graphql-tag";
//
import Snackbar from "@material-ui/core/Snackbar";
import Typography from "@material-ui/core/Typography";
import DialogForm from "components/buttonDialogForm";
import FormField from "components/formField";
import DescriptionIcon from '@material-ui/icons/Description';

export const GET_COOPERATIVE_NAME = gql`
  query GetCooperative($id: ID!) {
    cooperative(id: $id) {
      businessName
    }
  }
`;

export const CREATE_INVOICE = gql`
  mutation CreateInvoice($input: CreateInvoiceInput!) {
    createInvoice(input: $input) {
      code
      success
      message
    }
  }
`;

export default function({salary}) {
  const { id } = useParams();

  const {
    data: queryData,
    loading: queryLoading,
    error: queryError
  } = useQuery(GET_COOPERATIVE_NAME, {
    variables: { id }
  });

  const [
    createInvoice,
    { data: mutationData, loading: mutationLoading, error: mutationError }
  ] = useMutation(CREATE_INVOICE);

  const { register, handleSubmit, formState, errors } = useForm({
    //mode: "onChange"
  });

  const onSubmit = data => {
    //const { code, agreementDate, startDate } = data;
    const { } = data;

    const variables = {
      input: {
        //cooperative: queryData.cooperative.businessName
        salaryId: salary.id
      }
    };

    createInvoice({
      variables
    });
  };

  if (queryError) return <p>ERROR: {queryError.message}</p>;

  return (
    <Fragment>
      <Snackbar
        anchorOrigin={{ horizontal: "center", vertical: "bottom" }}
        open={mutationLoading}
        message={"Creazione delle fatture avviata con successo."}
      />
      <Snackbar
        anchorOrigin={{ horizontal: "center", vertical: "bottom" }}
        open={Boolean(mutationError)}
        message={"Si è verificato un errore nella creazione delle fatture."}
      /> 
      <DialogForm
        id="create-invoice"
        title={
          queryData &&
          `Creazione Fatture ${queryData.cooperative.businessName}`
        }
        subTitle={queryData && `La seguente procedura avvierà la creazione delle fatture per la società ${queryData.cooperative.businessName}, partendo dagli stipendi ${salary.title}.`}
        buttonTitle='Crea fatture'
        formState={formState}
        icon={DescriptionIcon}
        onSubmit={handleSubmit(onSubmit)}
      >
          {/* <FormField
            id="code"
            name="code"
            label="Codice"
            type="text"
            inputRef={register({ required: "Inserisci il codice." })}
            error={errors.password}
          />
          <FormField
            id="stip"
            name="agreementDate"
            label="Data stipula"
            type="date"
            inputRef={register({ required: "Inserisci data di stipula." })}
            error={errors.password}
          />
          <FormField
            id="start"
            name="startDate"
            label="Data inizio"
            type="date"
            inputRef={register({ required: "Inserisci data di inizio." })}
            error={errors.password}
          /> */}
      </DialogForm>
    </Fragment>
  );
}
